import { UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import { NewbuildingPromoBlackFridayBadge } from 'shared/components/NewbuildingPromoBlackFridayBadge';
import { IPromoInfo } from 'shared/types/newbuildingPromos';

import * as styles from './styles.css';

interface IPromoItemProps {
  promo: IPromoInfo;
  icon: React.ReactNode;
  subtitle: React.ReactNode;
  onClick(): void;
}

export function PromoItem(props: IPromoItemProps) {
  const { promo, onClick, icon, subtitle } = props;
  const { name, isBlackFriday } = promo;

  return (
    <div className={styles['container']} onClick={onClick} data-testid={'PromoItem'}>
      <div className={styles['icon-wrapper']}>
        <div className={styles['icon']}>{icon}</div>
        {isBlackFriday && (
          <div className={styles['black-friday-badge']}>
            <NewbuildingPromoBlackFridayBadge size={22} />
          </div>
        )}
      </div>
      <div className={styles['description']}>
        <div className={styles['title']}>
          <UIHeading4 as="h4">{name}</UIHeading4>
        </div>
        {subtitle}
      </div>
    </div>
  );
}
